module.exports = __webpack_public_path__ + "img/loading.7a24f52a.gif";